import { render } from "./vue-file-preview.vue?vue&type=template&id=709e26ad&ts=true"
import script from "./vue-file-preview.vue?vue&type=script&lang=ts"
export * from "./vue-file-preview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../ss/AZ/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__